import { Box, Container, Stack } from '@mui/material';
import type { ApprovalFlowInvoiceTypes } from '@weft/api-definition';
import { isNotEmptyArray, isNotNullOrUndefined, isNullOrUndefined } from '@weft/utils';
import { VyPageLayout } from 'apps/app/src/components/new-design/layout/VyPageLayout';
import { withGlobalSearchParams } from 'apps/app/src/components/utility/GlobalSearchParamsBoundary';
import { useGetApprovalFlowInvoicesList } from 'apps/app/src/hooks/requests/use-get-approval-flow-invoices-list';
import { useEffect, useState } from 'react';
import { DynamicInvoiceViewPage } from '../DynamicInvoiceViewPage';
import { ApprovalFlowHeader } from './approval-flow-page-components/ApprovalFlowHeader';
import { ApprovalFlowInvoicesList } from './approval-flow-page-components/ApprovalFlowInvoicesList';
import { useSelectedInvoiceStateParam } from './approval-flow-page-hooks/use-selected-invoice-state-param';

const ApprovalFlowPage: React.FC = () => {
  const [filter, setFilter] = useState<ApprovalFlowInvoiceTypes[]>([]);
  const { data: invoiceData } = useGetApprovalFlowInvoicesList(filter);
  const [selectedInvoiceId, setSelectedInvoiceId] = useSelectedInvoiceStateParam(isNotEmptyArray(invoiceData) ? invoiceData[0].invoiceId : undefined);

  useEffect(() => {
    if (isNotEmptyArray(invoiceData)) {
      const selectedInvoice = invoiceData.find(invoice => invoice.invoiceId === selectedInvoiceId);

      if (isNullOrUndefined(selectedInvoice)) {
        const [firstNewInvoice] = invoiceData;
        setSelectedInvoiceId(firstNewInvoice.invoiceId);
      }
    }
  }, [invoiceData, selectedInvoiceId, setSelectedInvoiceId]);

  return (
    <VyPageLayout
      path={['Invoices', 'Monthly Invoices Approval']}
      title='Monthly Invoices Approval'
      sx={{
        padding: '0',
        overflow: 'hidden',
      }}
    >
      <Stack
        overflow="hidden"
        height="100%"
        maxHeight="100%"
        direction="row"
      >
        <Box>
          {isNotEmptyArray(invoiceData)}
          <ApprovalFlowInvoicesList
            invoicesData={invoiceData}
            selectedInvoiceId={selectedInvoiceId ?? undefined}
            onInvoiceClick={(invoiceId) => setSelectedInvoiceId(invoiceId)}
            onFiltersChange={(newFilter) => setFilter(newFilter)}
          />
        </Box>
        {isNotNullOrUndefined(selectedInvoiceId) && (
          <Box
            width="100%"
            position="relative"
            sx={{ overflowY: 'auto' }}
          >
            <Container
              maxWidth='lg'
            >
              <Box paddingX={3}>
                <Box sx={{
                  backgroundColor: '#F5F5F5',
                  top: 0, 
                  position: 'sticky',
                  zIndex: 1100, 
                  paddingTop: '10px',
                }}
                >
                  <ApprovalFlowHeader
                    onInvoiceChange={(invoiceId) => setSelectedInvoiceId(invoiceId)}
                    invoiceData={invoiceData}
                    selectedInvoiceId={selectedInvoiceId}
                  />
                </Box>
                {isNotEmptyArray(invoiceData) && invoiceData.find(invoice => invoice.invoiceId === selectedInvoiceId) && (
                  <DynamicInvoiceViewPage
                    doNotUsePageLayout
                    noRedirectOnApprove
                    id={selectedInvoiceId}
                    idType='Invoice'
                  />
                )}
              </Box>
            </Container>
          </Box>
        )}
      </Stack>
    </VyPageLayout>
  );
};

const ApprovalFlowPageWithGlobalSearchParams = withGlobalSearchParams(ApprovalFlowPage);

export { ApprovalFlowPageWithGlobalSearchParams as ApprovalFlowPage };